
<div *ngIf="hasPermissions.readMarketData && hasPermissions.corePriceTargetRead && hasPermissions.coreCompanyFinancialRead && showPortfolioOptix" class="card mt-2" id="portfolioOptix">
  <div class="card-header d-flex flex-row justify-content-between">
    <h3>
      <span class="title-h3">{{"PORTFOLIO_OPTIX.PORTFOLIO" | translate}} </span><span class="subtitle-h3">{{"PORTFOLIO_OPTIX.OPTIX" | translate}} ({{ currentCount }})</span>
    </h3>
    <button class="btn btn-outline-teal" (click)="expandPortfolioOptix()">{{(isExpanded ? "PORTFOLIO_OPTIX.COLLAPSE" : "PORTFOLIO_OPTIX.EXPAND") | translate}}</button>
  </div>
  <div class="w-100 d-flex flex-column flex-wrap" style="gap: 10px; padding: 24px 24px 0;">
    <div class="d-flex flex-row justify-content-end" style="gap: 16px">
      <div class="optix-filter">
        <div class="font-medium">{{"PORTFOLIO_OPTIX.BOD" | translate}}:</div>
        <div class="btn-group" role="group" >
          <button type="button"
                  [ngClass]="{'active': showBod === true}"
                  class="btn btn-outline-secondary"
                  id="bodYes"
                  (click)="handleSetFilter($event)">
            Yes
          </button>
          <button type="button"
                  [ngClass]="{'active': showBod === false}"
                  class="btn btn-outline-secondary"
                  id="bodNo"
                  (click)="handleSetFilter($event)">
            No
          </button>
        </div>
      </div>
      <div class="optix-filter">
        <div class="font-medium">{{"PORTFOLIO_OPTIX.OWNERSHIP" | translate}}:</div>
        <div class="btn-group" role="group" >
          <button type="button"
                  [ngClass]="{'active': showOwnership === true}"
                  class="btn btn-outline-secondary"
                  id="ownershipGTE"
                  (click)="handleSetFilter($event)">
            &ge;10%
          </button>
          <button type="button"
                  [ngClass]="{'active': showOwnership === false}"
                  class="btn btn-outline-secondary"
                  id="ownershipLT"
                  (click)="handleSetFilter($event)">
            &lt;10%
          </button>
        </div>
      </div>
      <div class="optix-filter">
        <div class="font-medium">{{"PORTFOLIO_OPTIX.KEY_INFLECTION_LESS_THAN_YEAR" | translate}}:</div>
        <div class="btn-group" role="group" >
          <button type="button"
                  [ngClass]="{'active': showKeyInflection === true}"
                  class="btn btn-outline-secondary"
                  id="keyInflectionLT"
                  (click)="handleSetFilter($event)">
            &lt;1Yr
          </button>
          <button type="button"
                  [ngClass]="{'active': showKeyInflection === false}"
                  class="btn btn-outline-secondary"
                  id="keyInflectionGTE"
                  (click)="handleSetFilter($event)">
            &ge;1Yr
          </button>
        </div>
      </div>
    </div>
    <div class="d-flex flex-row justify-content-end" style="gap: 16px">
      <div class="optix-filter">
        <div class="font-medium">Restricted:</div>
        <div class="blotter-filters" role="group">
          <ng-container *ngFor="let filter of restrictionFilter">
            <div class="blotter-checkbox" (click)="filter.state = !filter.state; resetChart()">
              <div class="blotter-checkbox-icon {{ filter.style }}" [ngClass]="{'active': filter.state}"></div>
              <div class="blotter-checkbox-label">{{ filter.label }}</div>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="optix-filter">
        <div class="font-medium">Blotter:</div>
        <div class="blotter-filters" role="group">
          <ng-container *ngFor="let filter of blotterFilter">
            <div class="blotter-checkbox" (click)="filter.state = !filter.state; resetChart()">
              <div class="blotter-checkbox-icon {{ filter.style }}" [ngClass]="{'active': filter.state}"></div>
              <div class="blotter-checkbox-label">{{ filter.label }}</div>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <div echarts [options]="chartOption" (chartInit)="onChartInit($event)" [merge]="updateOptions" class="line-chart px-1"></div>

  <rms-portfolio-optix-table
    [isPortfolioTable]="true"
    [selectedItems]="selectedPortfolio"
    [isPortfolio]="isPortfolio.bind(this)"
    (onRemoveAll)="clearSelectedPortfolio()"
    (onRemoveOne)="clearOnePortfolio($event)"
    (onValueChange)="handleValueChange($event)"
    (onAddCompany)="handleAddSelectedCompany($event)"
    (onEdit)="handleEditChange($event)"
    >
  </rms-portfolio-optix-table>

  <rms-portfolio-optix-table
  [isPortfolioTable]="false"
  [selectedItems]="selectedNonPortfolio"
  [isPortfolio]="isPortfolio.bind(this)"
  (onRemoveAll)="clearSelectedNonPortfolio()"
  (onRemoveOne)="clearOneNonPortfolio($event)"
  (onValueChange)="handleValueChange($event)"
  (onAddCompany)="handleAddCompany($event)"
  (onEdit)="handleEditChange($event)"
  >
  </rms-portfolio-optix-table>

</div>
